export const getPageParams = () => (window as any)?.signInPageParam || (window as any)?.signUpPageParam